export const getAccessToken = () => localStorage.getItem('accessToken')
